import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-title',
  templateUrl: './dashboard-title.component.html',
  styleUrls: ['./dashboard-title.component.css']
})
export class DashboardTitleComponent implements OnInit {
  @Input() name: string;
  @Input() headerTitle: string;
  @Input() subTitle: string;
  constructor() { }

  ngOnInit() {
  }
  setSelectedOption(a) {
	// TODO:
  }

}
